export const CHECKLIST_PHASES = [
  {
    id: 'twelve-plus',
    title: '12+ Months Before',
    subtitle: 'Dream, decide, and lock in the big three',
    tasks: [
      { id: 'tp-budget', label: 'Agree your overall budget and who is contributing', link: '/tips-inspiration/how-much-does-a-wedding-in-malta-cost', linkLabel: 'Read our 2026 budget guide' },
      { id: 'tp-guest-list', label: 'Draft a first guest list to size your venue' },
      { id: 'tp-date', label: 'Choose your season and a shortlist of dates', hint: 'May, June, September and early October book out first in Malta.' },
      { id: 'tp-ceremony', label: 'Decide on a church or civil ceremony and book the church or licensed venue' },
      { id: 'tp-reception', label: 'Visit and book your reception venue', link: '/tips-inspiration/best-wedding-venues-malta-gozo', linkLabel: 'Explore the best venues in Malta & Gozo' },
      { id: 'tp-planner', label: 'Decide whether to hire a wedding planner or coordinator' },
      { id: 'tp-moodboard', label: 'Start a mood board for colours, flowers and styling' },
      { id: 'tp-engagement', label: 'Book an engagement shoot (great for save-the-dates)' },
    ],
  },
  {
    id: 'nine-twelve',
    title: '9 to 12 Months Before',
    subtitle: 'Book the suppliers who only do one wedding a day',
    tasks: [
      { id: 'nt-photo', label: 'Book your photographer and videographer' },
      { id: 'nt-caterer', label: 'Book your caterer if your venue is not full-service' },
      { id: 'nt-music', label: 'Book the band and/or DJ', link: '/tips-inspiration/choosing-the-right-wedding-band-malta', linkLabel: 'How to choose a wedding band' },
      { id: 'nt-dress', label: 'Start wedding dress shopping and book bridal appointments' },
      { id: 'nt-party', label: 'Choose your bridal party and ask them officially' },
      { id: 'nt-hotels', label: 'Block-book hotel rooms for travelling guests' },
      { id: 'nt-save-dates', label: 'Send save-the-dates, especially to guests flying in', link: '/tips-inspiration/destination-wedding-travel-guide', linkLabel: 'Destination wedding travel guide' },
      { id: 'nt-website', label: 'Set up a wedding website or group chat with travel details' },
    ],
  },
  {
    id: 'six-nine',
    title: '6 to 9 Months Before',
    subtitle: 'The look and feel comes together',
    tasks: [
      { id: 'sn-order-dress', label: 'Order your wedding dress (allow 4 to 6 months for delivery)' },
      { id: 'sn-groom', label: 'Choose the groom and groomsmen attire' },
      { id: 'sn-florist', label: 'Book your florist and agree the floral concept' },
      { id: 'sn-hmua', label: 'Book your hair and makeup artist' },
      { id: 'sn-cars', label: 'Book wedding cars and guest transport' },
      { id: 'sn-cake', label: 'Book a cake tasting and choose your cake designer' },
      { id: 'sn-registry', label: 'Set up your gift list or honeymoon fund' },
      { id: 'sn-honeymoon', label: 'Plan the honeymoon and check both passports are valid' },
    ],
  },
  {
    id: 'four-six',
    title: '4 to 6 Months Before',
    subtitle: 'Paper, rings and the ceremony itself',
    tasks: [
      { id: 'fs-stationery', label: 'Order invitations, menus, place cards and signage' },
      { id: 'fs-bridesmaids', label: 'Choose and order bridesmaids dresses' },
      { id: 'fs-course', label: 'Church weddings: meet your parish priest and book the marriage preparation course' },
      { id: 'fs-ceremony', label: 'Plan ceremony music, readings and who will do them' },
      { id: 'fs-rings', label: 'Choose your wedding rings' },
      { id: 'fs-extras', label: 'Book extras: fireworks, photo booth, late-night food, kids entertainment' },
      { id: 'fs-rehearsal-dinner', label: 'Plan the rehearsal dinner or welcome drinks' },
    ],
  },
  {
    id: 'two-four',
    title: '2 to 4 Months Before',
    subtitle: 'Invitations out, paperwork in',
    tasks: [
      { id: 'tf-invites', label: 'Send invitations with an RSVP date 4 to 6 weeks before the wedding' },
      { id: 'tf-registry', label: 'File your marriage request with the Public Registry (at least 6 weeks before the date)', hint: 'Foreign nationals may need translated and apostilled documents, so start early.' },
      { id: 'tf-trial', label: 'Hair and makeup trial', link: '/tips-inspiration/getting-married-in-the-heat-malta', linkLabel: 'Summer wedding beauty tips' },
      { id: 'tf-menu', label: 'Final menu tasting and confirm the drinks package' },
      { id: 'tf-fitting', label: 'First dress fitting' },
      { id: 'tf-accessories', label: 'Buy shoes, veil, jewellery and accessories' },
      { id: 'tf-vows', label: 'Write your vows and brief the speech-givers' },
      { id: 'tf-coaches', label: 'Confirm guest coaches and shuttle timings' },
    ],
  },
  {
    id: 'one-month',
    title: '1 Month Before',
    subtitle: 'Final numbers and the master timeline',
    tasks: [
      { id: 'om-rsvps', label: 'Chase RSVPs and give final numbers to the caterer' },
      { id: 'om-seating', label: 'Create the seating plan' },
      { id: 'om-final-fitting', label: 'Final dress fitting and collect the dress' },
      { id: 'om-timeline', label: 'Write the day-of timeline and share it with every supplier' },
      { id: 'om-payments', label: 'Confirm final payments and who is handing them over' },
      { id: 'om-favours', label: 'Prepare favours and welcome bags' },
      { id: 'om-shoes', label: 'Break in your wedding shoes' },
      { id: 'om-rings', label: 'Collect the rings and check the engraving' },
    ],
  },
  {
    id: 'final-week',
    title: 'The Final Week',
    subtitle: 'Delegate everything, then breathe',
    tasks: [
      { id: 'fw-confirm', label: 'Reconfirm arrival times with all suppliers' },
      { id: 'fw-weather', label: 'Check the forecast and confirm the weather plan with your venue' },
      { id: 'fw-emergency', label: 'Pack the emergency kit: plasters, safety pins, fan, sunscreen, blotting paper' },
      { id: 'fw-steam', label: 'Steam the dress and suits' },
      { id: 'fw-beauty', label: 'Nails, brows and any last beauty appointments' },
      { id: 'fw-envelopes', label: 'Prepare payment and tip envelopes for a trusted person to hand out' },
      { id: 'fw-honeymoon', label: 'Pack for the honeymoon' },
      { id: 'fw-rehearsal', label: 'Ceremony rehearsal' },
    ],
  },
  {
    id: 'wedding-day',
    title: 'The Wedding Day',
    subtitle: 'Your only job is to enjoy it',
    tasks: [
      { id: 'wd-breakfast', label: 'Eat breakfast and keep drinking water' },
      { id: 'wd-rings', label: 'Hand the rings and documents to the best man' },
      { id: 'wd-phone', label: 'Give your phone to a bridesmaid and be present' },
      { id: 'wd-golden', label: 'Slip away for 20 minutes of golden hour portraits' },
      { id: 'wd-moment', label: 'Take one quiet moment together and look around the room' },
    ],
  },
  {
    id: 'after',
    title: 'After the Wedding',
    subtitle: 'Wrap up and relive it',
    tasks: [
      { id: 'af-thanks', label: 'Send thank-you notes within three months' },
      { id: 'af-returns', label: 'Return hired suits, décor and rentals' },
      { id: 'af-preserve', label: 'Have the dress cleaned and preserved, and the bouquet dried' },
      { id: 'af-album', label: 'Choose your photos and order the album' },
      { id: 'af-names', label: 'Update names on documents if you are changing them' },
      { id: 'af-submit', label: 'Submit your wedding to I DO to be featured', link: '/submit-wedding', linkLabel: 'Submit your wedding' },
    ],
  },
];
